import React from 'react'
import ACLCheckPermission from '../ACLCheckPermission'

const Header = ({ showEdit }) => (
    <thead>
        <tr className="audience-list audience-list--header">
            <th className="audience-list audience-list--audience">Role ID</th>
            <th className="audience-list audience-list--audience">Role Name</th>
            <th className="audience-list audience-list--audience">Created</th>
            {showEdit && <th className="audience-list audience-list--edit">Edit</th>}
        </tr>
    </thead>
)

export default Header
